import React from "react";
import "../styles/Notifications.css";

const getTypeLabel = (typeRaw) => {
  const type = String(typeRaw || "info").toLowerCase();
  if (type === "success") return "✓";
  if (type === "error") return "✕";
  if (type === "warning") return "!";
  return "i";
};

const formatTime = (timestamp) => {
  if (!timestamp) return "";
  const date = new Date(timestamp);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleTimeString();
};

const Notifications = ({ notifications = [], loading = false }) => {
  const items = Array.isArray(notifications) ? notifications : [];

  return (
    <section className="notif-widget notif-widget-full">
      <header className="notif-widget-header">
        <h2 className="notif-widget-title">🔔 Notificaciones</h2>
        <span className="notif-widget-count">{items.length}</span>
      </header>

      {loading && items.length === 0 ? (
        <div className="notif-widget-state">
          <div className="notif-widget-spinner" />
          <p>⏳ Cargando notificaciones...</p>
        </div>
      ) : (
        <div className="notif-widget-list notif-widget-list-horizontal">
          {items.length > 0 ? (
            items.map((notification, index) => {
              const type = String(notification?.type || "info").toLowerCase();
              const accent = notification?.color || "#00ffb3";
              const key = notification?.id || `${notification?.timestamp || "notif"}-${index}`;

              return (
                <article
                  key={key}
                  className={`notif-card notif-${type}`}
                  style={{ "--notif-accent": accent }}
                  title={notification?.message || ""}
                >
                  <div className="notif-card-top">
                    <span className="notif-card-icon">{notification?.icon || "📌"}</span>
                    <span className={`notif-card-type notif-${type}`}>{getTypeLabel(type)}</span>
                  </div>

                  <div className="notif-card-content">
                    <strong className="notif-card-title">{notification?.title || "Notificación"}</strong>
                    <p className="notif-card-message">{notification?.message || "Sin detalle"}</p>
                    <time className="notif-card-time">{formatTime(notification?.timestamp)}</time>
                  </div>
                </article>
              );
            })
          ) : (
            <div className="notif-widget-state notif-widget-empty">
              <p>✅ Sin notificaciones</p>
            </div>
          )}
        </div>
      )}
    </section>
  );
};

export default React.memo(Notifications);
